import { createFileRoute } from '@tanstack/react-router';
import { CHECKLIST_CODE } from '@cis/api-client';
import { checklistQuery, runQuery } from '../../api/checklists.ts';
import { NotFoundChecklist } from '../../features/checklists/not-found.tsx';
import { RunPage } from '../../features/checklists/run-page.tsx';
import { runIdOf } from '../../features/checklists/search.ts';

// One checklist run (T28): results, complete, sign-off and correcting runs.
export const Route = createFileRoute('/_authed/checklists/$code/runs/$runId')({
  loader: ({ context, params }) => {
    const id = runIdOf(params.runId);
    if (id === undefined || !CHECKLIST_CODE.test(params.code)) return;
    void context.queryClient.prefetchQuery(runQuery(id));
    void context.queryClient.prefetchQuery(checklistQuery(params.code));
  },
  component: RunRoute,
});

function RunRoute(): React.JSX.Element {
  const { code, runId } = Route.useParams();
  const id = runIdOf(runId);
  if (id === undefined || !CHECKLIST_CODE.test(code)) return <NotFoundChecklist />;
  return <RunPage key={id} code={code} runId={id} />;
}
